/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelatedDossierResponse
 */
export interface RelatedDossierResponse {
    /**
     * 
     * @type {string}
     * @memberof RelatedDossierResponse
     */
    said?: string;
}

/**
 * Check if a given object implements the RelatedDossierResponse interface.
 */
export function instanceOfRelatedDossierResponse(value: object): boolean {
    return true;
}

export function RelatedDossierResponseFromJSON(json: any): RelatedDossierResponse {
    return RelatedDossierResponseFromJSONTyped(json, false);
}

export function RelatedDossierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedDossierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
    };
}

export function RelatedDossierResponseToJSON(value?: RelatedDossierResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
    };
}

